"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _en_US = _interopRequireDefault(require("antd/es/locale/en_US"));

var _en_US2 = _interopRequireDefault(require("../locales/en_US.json"));

var EnLang = {
  antd: _en_US.default,
  locale: 'en-US',
  messages: (0, _objectSpread2.default)({}, _en_US2.default)
};
var _default = EnLang;
exports.default = _default;